import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ValidacaoService} from './../../service/validacao.service';
import {NgForm} from '@angular/forms';
import {GlobalService} from '../../service/global.service';
import {MenuItem, Message} from 'primeng/api';
import {UtilApi} from '../../service/api/util.api';
import {
    BntProps,
    Dependencia,
    Etapa,
    Evento,
    EventoOperacao,
    EventoPrincipal,
    EventoProcessamento,
    EventoTransmissao,
    JanelaPermissaoOcorrencia,
    ObjetoPainel,
    ScheduleExecucao,
    ServicoVinculado,
    SubfluxoPossivel,
    FTA,
    UserAplicacao,
    Cliente,
} from './../../model/catalogo';
import {
    TipoEvento,
    TipoPeriodicidade,
    TipoTrigger,
} from './../../model/constantes';
import {ConstantesApiService} from './../../service/api/constantes.api';
import {PesquisasFiltroApiService} from './../../service/api/pesquisas-filtro.api';
import {FtaService} from './../../service/fta.service';
import {ModalService} from './../../service/modal.service';
import {ToadMensagemService} from './../../service/toad-mensagem.service';
import {LoginComponent} from '../login/login.component';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

@Component({
    selector: 'app-cadastro-evento',
    templateUrl: './cadastro-evento.component.html',
    styleUrls: ['./cadastro-evento.component.css'],
    providers: [ValidacaoService],
})
export class CadastroEventoComponent implements OnInit {
    fta: FTA = new FTA();
    isFTAEdicao: boolean = false;
    isEventoSalvar: boolean = false;

    painelList: Array<ObjetoPainel> = new Array<ObjetoPainel>();

    evento: Evento = new Evento();
    backupEvento: any;

    arrayEvento: Array<Evento> = new Array<Evento>();

    tipoEvento: TipoEvento = new TipoEvento();
    tipoTrigger: TipoTrigger = new TipoTrigger();
    tipoPeriodicidade: TipoPeriodicidade = new TipoPeriodicidade();

    //  CONSTANTES
    triggers: Array<TipoTrigger> = new Array<TipoTrigger>();
    eventos: Array<TipoEvento> = new Array<TipoEvento>();
    periodicidades: Array<TipoPeriodicidade> = new Array<TipoPeriodicidade>();
    servicosVinculados: Array<ServicoVinculado> = new Array<ServicoVinculado>();
    listaEventos: Array<Evento> = new Array<Evento>();

    etapaSelecionado: number;

    sourceServicos = new Array<ServicoVinculado>();
    targetServicos = new Array<ServicoVinculado>();

    // grupoAdicionado: Number;

    novoGrupo: Number;

    @Output() eventoAdicionado = new EventEmitter();
    @Output() eventoCancelado = new EventEmitter();

    //variaves de edicao
    @Input() recebeFta: FTA;
    @Input() listaGrupo: any;

    etapasEdicao = [];

    dependencias = [];
    items: MenuItem[];
    paineis = [];
    auxPainel = [];
    ultimoIdBtn = 0;
    ultimoId = 0;
    botoes = [];
    lista = [];
    janelaPermissaoOcorrencias = [];
    scheduleExecucao = [];
    msgs: Message[] = [];
    cols = [];
    coluna = [];
    operacaos: any;
    nomeDetalheEvento: string;
    selectedRange: any;
    transmissao: boolean = true;
    permissoes: boolean = true;
    parametros: boolean = true;
    operacao: boolean = true;
    processamento: boolean = true;
    validaDependencia: boolean = true;
    loadingGrupo: boolean = false;
    display: boolean = false;
    checked: boolean = false;
    checkedGrupo: any = [];

    botaoFinalizar: boolean = false;

    value: number = 0; //TODO: terminar logica de preenchimento de tela

    chaveComposta: any;

    eventoPosicao: Number;

    subFluxo: Number;

    eventoSelecionado: any;
    numeroEtapa: any;
    objetoEtapa: any;
    newQtdSegundosMaxEntreEventos: any;
    novaJanelaPermissaoOcorrencia: any;
    novaScheduleExecucao: any;

    //testes
    novoEventoTransmissao: any;
    novoEventoPermissoes: any;
    novoEventoOperacao: any;
    novoEventoParametros: any;
    novoEventoProcessamento: EventoProcessamento;

    btn: BntProps = new BntProps();
    eventoTransmissao: EventoTransmissao = new EventoTransmissao();
    eventoPrincipal: EventoPrincipal = new EventoPrincipal();
    backupEventoPrincipal: any;
    selected: Array<SubfluxoPossivel> = new Array<SubfluxoPossivel>();
    numeroSelecionado: Array<Number> = new Array<Number>();
    novaTransmissao: EventoTransmissao = new EventoTransmissao();
    novaListaDependencia: Array<Dependencia> = new Array<Dependencia>();

    //variaveis de controle para cancelar evento
    indexEtapa: number;
    indexEvento: number;
    isNovoEvento: boolean = false;

    constructor(
        private globalService: GlobalService,
        private pesquisaService: PesquisasFiltroApiService,
        private messageService: ToadMensagemService,
        private ftaService: FtaService,
        private modalService: ModalService,
        private utilApi: UtilApi,
        private validacaoService: ValidacaoService,
        private constantesService: ConstantesApiService
    ) {
        this.carregarConstantes();
    }

    ngOnInit() {


        $('#pills-tab a[href="#pills-evento"]').tab('show');

        this.utilApi.invocacaoRemotaComRetry(
            5,
            1000,
            this,
            CadastroEventoComponent.prototype.carregarConstantes
        );
        this.utilApi.invocacaoRemotaComRetry(
            5,
            1000,
            this,
            CadastroEventoComponent.prototype.listaServicosVinculados
        );

        this.cols = [
            {field: 'nrSubfluxo', header: 'Número'},
            {field: 'descricaoSubfluxo', header: 'Descrição'},
        ];

        this.coluna = [{field: 'grupo', header: 'Grupo'}];

        if (this.paineis.length === 0) {
            this.adicionarEtapa();
        }

        if (this.eventoPrincipal.etapas.length === 0) {
            this.criarNovaEtapa();
        }

        let t: any = `data-toggle="modal" data-target=".bs-example-modal-lg"`;

        this.utilApi.invocacaoRemotaComRetry(
            5,
            1000,
            this,
            CadastroEventoComponent.prototype.carregarConstantes
        );

        // carrega o menu do componentes de buttons
        this.items = [
            {
                label: 'Editar Evento',
                icon: 'fa fa-folder-open',
                command: (t) => {
                    this.carregaEvento();
                    this.abrirModal();
                },
            },
            {
                label: 'Excluir Evento',
                icon: 'pi pi-trash',
                command: (data) => {
                    this.excluirEvento();
                },
            },
        ];

        this.listaServicosVinculados();

        this.targetServicos = new Array<ServicoVinculado>();

        this.carregarConstantes();
    }

    //salva automaticamente as alterações da aba de evento no json principal
    ngDoCheck(): void {
        if (this.evento != undefined) {
            this.aoAdicionarFormEvento();
        }

        //monitora para verificar se foi acionado no botao salvar no utimo passo do wizard
        if (this.isEventoSalvar) {
            this.finishFunction();
        }
    }

    ngOnChanges() {
        this.fta = this.recebeFta;

        //vincula subfluxo padrao
        if (this.recebeFta.fta == 0) {
            this.selected.push(this.recebeFta.subfluxoPossiveis[0]);
            this.evento.subfluxoVinculado.push(
                Number(this.recebeFta.subfluxoPossiveis[0].nrSubfluxo)
            );
        }

        if (this.fta.versao > 0) {
            this.arrayEvento = this.fta.eventos;
            let etapasAux = [];
            this.isFTAEdicao = true;

            this.excluirEtapa(0, false);
            this.arrayEvento = this.fta.eventos;

            //recupera todas as etapas do FTA
            for (let i in this.fta.eventos) {
                etapasAux.push(this.fta.eventos[i].etapa);
            }

            //remove etapas duplicadas
            this.etapasEdicao = etapasAux.filter(function (este, i) {
                return etapasAux.indexOf(este) == i;
            });

            //Popula eventos em cada etapa
            for (let i = 0; i < this.etapasEdicao.length; i++) {
                this.criarNovaEtapa();
                for (let j in this.fta.eventos) {
                    if (this.fta.eventos[j].descricao === 'null') {
                        this.fta.eventos[j].descricao = null;
                    }

                    if (this.fta.eventos[j].formaConstrucaoChave === 'null') {
                        this.fta.eventos[j].formaConstrucaoChave = null;
                    }

                    if (this.fta.eventos[j].mensagemParaProtocoloEmSucesso === 'null') {
                        this.fta.eventos[j].mensagemParaProtocoloEmSucesso = null;
                    }

                    if (this.fta.eventos[j].mensagemParaProtocoloEmErro === 'null') {
                        this.fta.eventos[j].mensagemParaProtocoloEmErro = null;
                    }

                    if (this.fta.eventos[j].etapa === i + 1) {
                        this.eventoPrincipal.etapas[i].eventos.push(this.fta.eventos[j]);
                    }

                    if (this.fta.eventos[j].codTipoEvento == 1) {
                        if (this.fta.eventos[j].detalheEventoTransmissao.codLayout == 0) {
                            this.fta.eventos[j].detalheEventoTransmissao.codLayout = null;
                        }

                        if (this.fta.eventos[j].detalheEventoTransmissao.vrsLayout == 0) {
                            this.fta.eventos[j].detalheEventoTransmissao.vrsLayout = null;
                        }
                    }
                }
            }
        }
    }

    buscarNomeTrigger(codTrigger: any) {
        if (codTrigger != undefined) {
            let trigger = this.triggers.find(t => t.codigo == codTrigger);
            if (trigger != null) {
                return trigger.nome;
            } else {
                return '';
            }
            // return codTrigger ? this.triggers.find(t => t.codigo == codTrigger).nome : '';
        } else {
            return 0;
        }
    }

    // aoAdiconarSubFluxos(lista) {}

    //busca os serviços de Tipo Evento, Tipo Trigger, Tipo Periodicidade via API Rest
    carregarConstantes() {
        this.globalService.loading = true;
        this.constantesService.buscaTipoEvento(0).subscribe((eventos) => {
            this.eventos = eventos as Array<TipoEvento>;
            this.globalService.loading = false;
        });

        this.globalService.loading = true;
        this.constantesService.buscaTipoTrigger(0).subscribe((triggers) => {
            this.triggers = triggers as Array<TipoTrigger>;
            this.globalService.loading = false;
        });

        this.globalService.loading = true;
        this.constantesService
            .buscaTipoPeriodicidade(0)
            .subscribe((periodicidades) => {
                this.periodicidades = periodicidades as Array<TipoPeriodicidade>;
                this.globalService.loading = false;
            });
    }

    selectAba(aba: string): void {
        $('#pills-tab a[href="#pills-' + aba + '"]').tab('show');
    }

    cancelarEvento() {
        //limpa campo de parametros
        this.selectedRange = '';
        this.eventoSelecionado = false;
        this.eventoPrincipal = this.backupEventoPrincipal;
        this.evento = this.backupEvento;
        this.adicionarFormularioEvento();

        // this.display = false;
        $('#modalEvento').modal('hide');
        this.isEventoSalvar = false;
        this.eventoAdicionado.emit(this.evento);
    }

    // lista os serviços vinculados
    listaServicosVinculados() {
        let filtros: Array<any> = new Array<any>();
        this.ftaService.getServico(filtros).subscribe((listaServicos) => {
            this.sourceServicos = listaServicos as Array<ServicoVinculado>;

            this.deletarRegistrosDuplicados();
        });
    }

    deletarRegistrosDuplicados() {
        var originalArray = this.sourceServicos;
        var newArray = [];
        var lookupObject = {};

        function comparePorTipoEstado(a, b) {
            if (a.codTipoEstado < b.codTipoEstado) {
                return -1;
            }
            if (a.codTipoEstado < b.codTipoEstado) {
                return 1;
            }
            return 0;
        }

        function comparePorNome(a, b) {
            if (a.nome < b.nome) {
                return -1;
            }
            if (a.nome < b.nome) {
                return 1;
            }
            return 0;
        }

        this.sourceServicos.sort(comparePorTipoEstado);
        this.sourceServicos.sort(comparePorNome);

        //sobrescreve items com mesmo nome. O maior valor sempre será o último da lista
        for (var i in originalArray) {
            lookupObject[originalArray[i]['nome']] = originalArray[i];
        }
        //cria novo array sem itens duplicados
        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        this.sourceServicos = newArray;
    }

    editarEvento(nuEtapa, nuEvento) {
        if (this.evento === null) {
            this.evento = new Evento();
        }
        this.evento.evento = nuEvento;
        this.evento.etapa = nuEtapa;
        this.carregaEvento();
        localStorage.setItem('fta', JSON.stringify(this.evento));
        this.abrirModal();
    }

    // método que compara os eventos na memória com o evento passado no button.
    async carregaEvento() {
        //flag de monitoracao do botao salvar
        this.isEventoSalvar = false;

        //limpa subfluxos selecionados
        //this.selected = [];

        let existe: boolean = false;

        for (let i = 0; i < this.arrayEvento.length; i++) {
            if (
                this.arrayEvento[i].evento == this.evento.evento &&
                this.arrayEvento[i].etapa == this.evento.etapa
            ) {
                this.eventoPosicao = this.evento.evento;

                this.evento.grupo = this.arrayEvento[i].grupo;

                this.evento.grupo.map((item) => {
                    this.checkedGrupo[item] = true;
                });

                if (this.evento.descricao !== null) {
                    this.evento.descricao = this.arrayEvento[i].descricao;
                }

                this.evento.indMonitorarPeriodicidade =
                    this.arrayEvento[i].indMonitorarPeriodicidade;

                this.evento.codTipoEvento = this.arrayEvento[i].codTipoEvento;
                this.evento.codTipoTrigger = this.arrayEvento[i].codTipoTrigger;
                this.evento.codTipoPeriodicidade =
                    this.arrayEvento[i].codTipoPeriodicidade;

                this.evento.parametrosEntradaEvento =
                    this.arrayEvento[i].parametrosEntradaEvento;

                this.evento.permissaoUsoEvento = this.arrayEvento[i].permissaoUsoEvento;
                this.evento.cliente = this.arrayEvento[i].cliente;

                // TODO : solução foi autorizada pelos analista do BB, o ideal seria mudar a api para ela receber o objeto
                this.setListasTipoEvento(this.evento.codTipoEvento);

                this.setListasTipoTrigger(this.evento.codTipoTrigger);

                this.setListasTipoPeriodicidade(this.evento.codTipoPeriodicidade);

                this.evento.formaConstrucaoChave =
                    this.arrayEvento[i].formaConstrucaoChave;
                this.evento.mensagemParaProtocoloEmSucesso =
                    this.arrayEvento[i].mensagemParaProtocoloEmSucesso;
                this.evento.mensagemParaProtocoloEmErro =
                    this.arrayEvento[i].mensagemParaProtocoloEmErro;

                this.evento.servicosVinculados = this.arrayEvento[i].servicosVinculados;

                this.targetServicos = this.evento.servicosVinculados;


                this.listaGrupo.map((item, key) => {
                    var lista = this.evento.grupo.find(elemento => elemento == item.label);
                    if (lista) {
                        this.listaGrupo[key] = {label: lista, value: lista};
                    }
                });

//        this.evento.grupo.map((item, key) => {
//          this.listaGrupo.push({ label: item, value: item });
//        });

                this.evento.subfluxoVinculado = this.arrayEvento[i].subfluxoVinculado;

                this.evento.qtdSegundosMaxEntreEventos =
                    this.arrayEvento[i].qtdSegundosMaxEntreEventos;

                this.evento.dependencia = this.arrayEvento[i].dependencia;

                this.novaListaDependencia = this.evento.dependencia;

                this.newQtdSegundosMaxEntreEventos =
                    this.evento.qtdSegundosMaxEntreEventos;

                this.evento.janelaPermissaoOcorrencia =
                    this.arrayEvento[i].janelaPermissaoOcorrencia;

                this.novaJanelaPermissaoOcorrencia =
                    this.evento.janelaPermissaoOcorrencia;

                //testes
                this.novoEventoTransmissao =
                    this.arrayEvento[i].detalheEventoTransmissao;
                this.novoEventoOperacao = this.arrayEvento[i].detalheEventoOperacao;
                this.novoEventoProcessamento =
                    this.arrayEvento[i].detalheEventoProcessamento;

                this.evento.scheduleExecucao = this.arrayEvento[i].scheduleExecucao;

                this.novaScheduleExecucao = this.evento.scheduleExecucao;

                this.evento.detalheEventoTransmissao =
                    this.arrayEvento[i].detalheEventoTransmissao;

                if (this.arrayEvento[i].parametrosSelecionados) {
                    this.evento.parametrosSelecionados =
                        this.arrayEvento[i].parametrosSelecionados;
                }

                if (this.evento.detalheEventoTransmissao) {
                    this.evento.listaParametrosSelecionados =
                        this.evento.detalheEventoTransmissao.parmTransmissao;
                }

                this.novaTransmissao = this.evento.detalheEventoTransmissao;

                this.evento.detalheEventoOperacao =
                    this.arrayEvento[i].detalheEventoOperacao;
                this.evento.parametrosSelecionadosOperacao =
                    this.arrayEvento[i].parametrosSelecionadosOperacao;
                if (this.evento.detalheEventoOperacao) {
                    this.evento.listaParametrosSelecionadosOperacao =
                        this.evento.detalheEventoOperacao.parmOperacao;
                }
                //
                this.evento.detalheEventoProcessamento =
                    this.arrayEvento[i].detalheEventoProcessamento;

                existe = true;

                //habilita tipo Evento
                this.validacao(this.arrayEvento[i].codTipoEvento);

                if (this.isFTAEdicao) {
                    //habilita tipo Evento
                    // this.validacao(this.arrayEvento[i].codTipoEvento);

                    if (this.arrayEvento[i].grupo.length > 0) {
                        this.loadingGrupo = true;
                    }

                    //ajusta os subfluxos retornados na edicao
                    this.selected = [];
                    for (let j in this.recebeFta.subfluxoPossiveis) {
                        for (let k in this.arrayEvento[i].subfluxoVinculado) {
                            if (
                                this.arrayEvento[i].subfluxoVinculado[k] ==
                                this.recebeFta.subfluxoPossiveis[j].nrSubfluxo
                            ) {
                                this.selected.push(this.recebeFta.subfluxoPossiveis[j]);
                            }
                        }
                    }

                    //TODO AJUSTAR OS HORARIOS DE JANELA E SCHEDULE NA EDICAO
                    if (this.arrayEvento[i].janelaPermissaoOcorrencia.length > 0) {
                    }
                }

                break;
            }
        }

        if (!existe) {
            // this.evento.evento = objeto.evento;
            // this.evento.etapa = objeto.etapa;

            this.novoGrupo = null;
            this.evento.grupo = new Array<Number>();
            // this.evento.descricao = '';
            this.evento.indMonitorarPeriodicidade = false;
            this.checked = this.evento.indMonitorarPeriodicidade;

            this.tipoEvento = new TipoEvento();
            this.tipoTrigger = new TipoTrigger();
            this.tipoPeriodicidade = new TipoPeriodicidade();

            //seleciona evento transmissao por padrao
            this.evento.codTipoEvento = 1;

            //add grupo
            this.evento.grupo.push(this.listaGrupo[0].value);

            this.setListasTipoEvento(1);
            this.validacao(1);

            this.eventos = new Array<TipoEvento>();
            this.triggers = new Array<TipoTrigger>();
            this.periodicidades = new Array<TipoPeriodicidade>();

            this.carregarConstantes();
            //this.nomeDetalheEvento = '';

            this.evento.formaConstrucaoChave = '';
            this.evento.mensagemParaProtocoloEmSucesso = '';
            this.evento.mensagemParaProtocoloEmErro = '';

            this.targetServicos = new Array<ServicoVinculado>();
            this.sourceServicos = new Array<ServicoVinculado>();

            this.listaServicosVinculados();

            // Não limpa devido ser uma informação da tela anterior.
            // this.evento.subfluxoVinculado = new Array<Number>();

            // Limpa Dependencia, Janela e Schedule
            this.evento.servicosVinculados = new Array<ServicoVinculado>();

            this.evento.qtdSegundosMaxEntreEventos = null;

            this.evento.dependencia = new Array<Dependencia>();

            this.novaListaDependencia = new Array<Dependencia>();

            this.evento.janelaPermissaoOcorrencia =
                new Array<JanelaPermissaoOcorrencia>();

            this.novaJanelaPermissaoOcorrencia =
                new Array<JanelaPermissaoOcorrencia>();

            this.evento.scheduleExecucao = new Array<ScheduleExecucao>();

            this.novaScheduleExecucao = new Array<ScheduleExecucao>();

            // Limpa transmissão, operação e processamento
            this.evento.detalheEventoTransmissao = new EventoTransmissao();

            this.novaTransmissao = new EventoTransmissao();

            this.evento.detalheEventoOperacao = new EventoOperacao();

            this.evento.detalheEventoProcessamento = new EventoProcessamento();

            //testes
            this.novoEventoTransmissao = new EventoTransmissao();
            this.novoEventoProcessamento = new EventoProcessamento();
            this.novoEventoOperacao = new EventoOperacao();
        }
    }

    // método que busca os tipos de evento.
    setListasTipoEvento(codigo) {
        this.constantesService
            .buscaTipoEvento(0)
            .subscribe((eventos) => (this.eventos = eventos as Array<TipoEvento>));

        var existe = false;

        for (let i = 0; i < this.eventos.length; i++) {
            if (this.eventos[i].codigo == codigo) {
                existe = true;
                this.tipoEvento.codigo = this.eventos[i].codigo;
                this.tipoEvento.nome = this.eventos[i].nome;
                this.tipoEvento.descricao = this.eventos[i].descricao;
            }
        }
    }

    // método que busca os tipos de triggers.
    setListasTipoTrigger(codigo) {
        this.constantesService
            .buscaTipoTrigger(0)
            .subscribe(
                (triggers) => (this.triggers = triggers as Array<TipoTrigger>)
            );

        var existe = false;

        for (let i = 0; i < this.triggers.length; i++) {
            if (this.triggers[i].codigo == codigo) {
                existe = true;
                this.tipoTrigger.codigo = this.triggers[i].codigo;
                this.tipoTrigger.nome = this.triggers[i].nome;
                this.tipoTrigger.descricao = this.triggers[i].descricao;
            }
        }
    }

    // método que busca os tipos de periodicidade.
    setListasTipoPeriodicidade(codigo) {
        this.constantesService
            .buscaTipoPeriodicidade(0)
            .subscribe(
                (periodicidades) =>
                    (this.periodicidades = periodicidades as Array<TipoPeriodicidade>)
            );

        var existe = false;

        for (let i = 0; i < this.periodicidades.length; i++) {
            if (this.periodicidades[i].codigo == codigo) {
                existe = true;
                this.tipoPeriodicidade.codigo = this.periodicidades[i].codigo;
                this.tipoPeriodicidade.nome = this.periodicidades[i].nome;
                this.tipoPeriodicidade.descricao = this.periodicidades[i].descricao;
            }
        }
    }

    //  abre a modal evento.
    abrirModal() {
        $('#modalEvento').modal('show');
    }

    // recupera da tela de dependencia via @output
    aoAdiconarQtdSegundosMaxEntreEventos(event) {
        this.evento.qtdSegundosMaxEntreEventos = event.qtdSegundosMaxEntreEventos;
    }

    // onSubmitFormularioEvento(f: NgForm) {}

    /** Foi feita elterações nesse dois metos : adicionarEtapa, adicionarFormularioEvento */
    adicionarEtapa() {
        this.evento.etapa = this.auxPainel.push({
            id: ++this.ultimoId,
        });

        let objEtapa: ObjetoPainel = new ObjetoPainel();
        objEtapa.etapa = this.evento.etapa;
        this.painelList.push(objEtapa);
        this.numeroEtapa = objEtapa.etapa;
    }

    adicionarFormularioEvento() {
            //this.evento.etapa = this.numeroEtapa;

            this.btn.botao = this.evento;

            if (!this.targetServicos) {
                this.evento.servicosVinculados = this.targetServicos;
            }

            let arrayEtapa = this.eventoPrincipal.etapas[this.evento.etapa - 1].eventos;
            let arrayEventosAux2 = new Array<Evento>();
            let isEventoEdicao = false;

            this.eventoPrincipal.etapas[this.evento.etapa - 1].eventos = [];

            //this.painelList[this.etapaSelecionado].botoesList.push(this.btn);

            let arrayEventosAux = new Array<Evento>();

            for (let i in this.arrayEvento) {
                //remove os eventos temporarios
                if (this.arrayEvento[i].descricao != '????') {
                    arrayEventosAux.push(this.arrayEvento[i]);
                }

                //caso seja uma edição subustitui o evento no arrayEventos com os dados atuais
                if (
                    this.arrayEvento[i].etapa == this.evento.etapa &&
                    this.arrayEvento[i].evento == this.evento.evento
                ) {
                    this.arrayEvento[i] = this.evento;
                    isEventoEdicao = true;
                }
            }

            if (!isEventoEdicao) {
                this.arrayEvento = arrayEventosAux;
                this.arrayEvento.push(this.evento);

                //popula a lista de eventos dentro da etapa selecionada
                this.geraEventosEtapa();

                //this.recalculaNumeroEventoAdicionar();
            } else {
                this.geraEventosEtapa();
            }

            this.evento = new Evento();
            this.eventoAdicionado.emit(this.arrayEvento);
    }

    geraEventosEtapa() {
        for (let i in this.arrayEvento) {
            if (this.evento.etapa == this.arrayEvento[i].etapa) {
                this.eventoPrincipal.etapas[this.evento.etapa - 1].eventos.push(
                    this.arrayEvento[i]
                );
            }
        }
    }

    //recalcula numero dos eventos dentro de cada etapa
    recalculaNumeroEventoAdicionar() {
        let numeroEvento = 1;
        let arrayEventosAux_ = new Array<Evento>();
        for (let et of this.eventoPrincipal.etapas) {
            if (et.eventos.length > 0) {
                for (let i in et.eventos) {
                    et.eventos[i].evento = numeroEvento;
                    numeroEvento++;
                    arrayEventosAux_.push(et.eventos[i]);
                }
            }
        }
        this.arrayEvento = arrayEventosAux_;
    }

    // metodo criado paraa incrementar o evento
    adicionarNovoEvento() {
        this.display = true;

        this.evento = new Evento();

        this.evento.evento = this.lista.push({id: this.ultimoIdBtn++});
    }

    // método usado para controlar a lista de botões
    newAdicionarFormularioEvento(totalEtapaSelecionada) {
        this.etapaSelecionado = totalEtapaSelecionada;
        let btn: BntProps = new BntProps();
        var totalBtns = 0;
        let eventoAux = new Evento();

        if (totalEtapaSelecionada < 1) {
            btn.label = 'Evento ';
            btn.index =
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.length +
                1;
            this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
            //this.eventoPrincipal.etapas[this.etapaSelecionado].indexEvento = this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.length;
        } else {
            totalBtns = this.totalDeBtnsEmTela(
                this.eventoPrincipal.etapas,
                this.etapaSelecionado
            );
            let proximoIndexBtn = totalBtns + 1;

            if (
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.length < 1
            ) {
                btn.label = 'Evento';
                // btn.index = proximoIndexBtn;
                btn.index = this.recuperaUltimoEvento();
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
            } else {
                btn.label = 'Evento';
                // btn.index = totalBtns + 1;
                btn.index = this.recuperaUltimoEvento();
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
            }
            //this.recalcularEventos();
        }

        eventoAux.etapa = totalEtapaSelecionada + 1;
        eventoAux.evento = this.recuperaUltimoEvento();
        eventoAux.descricao = '????';
        //index evento etapa
        let indiceEventoEtapa =
            this.eventoPrincipal.etapas[this.etapaSelecionado].eventos.length;
        if (indiceEventoEtapa == 0) {
            this.eventoPrincipal.etapas[this.etapaSelecionado].indexEvento =
                indiceEventoEtapa;
        } else {
            this.eventoPrincipal.etapas[this.etapaSelecionado].indexEvento =
                indiceEventoEtapa + 1;
        }

        //this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
        this.eventoPrincipal.etapas[this.etapaSelecionado].eventos.push(eventoAux);

        this.selecionarEtapa(totalEtapaSelecionada, btn.index);
        this.carregaEvento();
        this.abrirModal();
        this.indexEtapa = totalEtapaSelecionada;
        this.indexEvento = this.eventoPrincipal.etapas[this.etapaSelecionado].eventos.length - 1;
        this.isNovoEvento = true;
    }

    recuperaUltimoEvento(): number {
        let sizeListEventos = this.arrayEvento.length;
        let listNumeroEventos = [];
        let ultimoEvento;
        for (let i in this.arrayEvento) {
            listNumeroEventos.push(this.arrayEvento[i].evento);
        }
        if (listNumeroEventos.length > 0) {
            ultimoEvento = Math.max.apply(null, listNumeroEventos);
        } else {
            ultimoEvento = 0;
        }
        return ultimoEvento + 1;
    }

    // calcula a qtd de button na tela
    totalDeBtnsEmTela(etapas: Array<Etapa>, indexMax): number {
        let count = 0;
        let total = 0;

        while (count <= indexMax) {
            total += etapas[count].botoesList.length;
            count++;
        }
        return total;
    }

    selecionarEtapa(etapaPosicao, eventoPosicao) {
        if (this.evento === null) {
            this.evento = new Evento();
        }
        this.eventoSelecionado = eventoPosicao;
        this.etapaSelecionado = etapaPosicao;
        this.evento.etapa = etapaPosicao + 1;
        this.evento.evento = this.recuperaUltimoEvento();
    }

    criarNovaEtapa() {
        let etapa: Etapa = new Etapa();
        etapa.id++;
        etapa.titulo = 'Etapa';
        this.eventoPrincipal.etapas.push(etapa);
    }

    excluirEtapa(etapaTela: number, message: boolean) {
        if (etapaTela != 0) {
            while (this.eventoPrincipal.etapas[etapaTela].eventos.length != 0) {
                this.eventoPrincipal.etapas[etapaTela].eventos.map((value, index) => {
                    this.removerEvento(etapaTela, index, value.evento, value.etapa);
                });
            }
        }

        this.eventoPrincipal.etapas.splice(etapaTela, 1);
        let arrayEventAux = [];

        // for (let i in this.arrayEvento) {
        //   if (this.arrayEvento[i].etapa != etapaTela + 1) {
        //     arrayEventAux.push(this.arrayEvento[i]);
        //   }
        // }
        // this.arrayEvento = arrayEventAux;
        // etapaTela--;
        // if (message) {
        //   this.messageService.addSuccessKey(
        //     "Etapa excluída com sucesso.",
        //     this.chaveComposta
        //   );
        // }
    }

    // método usado para controlar ação no evento que influenciará no Detalhamento de Evento
    validacao(codigo) {
        this.nomeDetalheEvento = this.eventos[codigo - 1].nome;

        switch (codigo.toString()) {
            case '1': {
                this.transmissao = false;
                this.operacao = true;
                this.processamento = true;
                break;
            }
            case '2': {
                this.operacao = false;
                this.transmissao = true;
                this.processamento = true;
                break;
            }
            case '3': {
                this.processamento = false;
                this.operacao = true;
                this.transmissao = true;
                break;
            }
            default: {
                break;
            }
        }
    }

    habilitaTipoEvento() {
        this.validacao(this.tipoEvento.codigo);
    }

    // método usado para adiconar dados do formulário de evento
    aoAdicionarFormEvento() {
        this.evento.subfluxoVinculado = [];

        this.evento.indMonitorarPeriodicidade = this.checked;

        let codTipoEvento: string = this.tipoEvento.codigo + '';
        if (codTipoEvento == '') {
            this.evento.codTipoEvento = null;
        } else {
            this.evento.codTipoEvento = this.tipoEvento.codigo;
        }

        let codTipoTrigger = this.tipoTrigger.codigo + '';
        if (codTipoTrigger == '') {
            this.evento.codTipoTrigger = null;
        } else {
            this.evento.codTipoTrigger = this.tipoTrigger.codigo;
        }

        let codTipoPeriodicidade = this.tipoPeriodicidade.codigo + '';
        if (codTipoPeriodicidade == '') {
            this.evento.codTipoPeriodicidade = null;
        } else {
            this.evento.codTipoPeriodicidade = this.tipoPeriodicidade.codigo;
        }

        var codigoStr = String(this.tipoTrigger.codigo);

        var obj = Number(this.tipoTrigger.codigo);

        if (obj == 4) {
            this.validaDependencia = false;
        } else {
            this.validaDependencia = true;
        }

        if (this.selected !== undefined || this.selected !== null) {
            for (var item of this.selected) {
                if (item != undefined) {
                    this.evento.subfluxoVinculado.push(item.nrSubfluxo);
                }
            }
        }
    }

    // método usado para setar servicos vinculados pelo @output e emit
    aoAdicionarServicosVinculados() {
        this.evento.servicosVinculados = this.targetServicos;
    }

    // método usado para setar as dependencias pelo @output e emit
    aoAdiconarDependencia(listaDependencias) {
        this.evento.dependencia = listaDependencias;
    }

    // método usado para setar as janela Permissão de Ocorrência pelo @output e emit
    aoAdiconarJanelaPermissao(listaJanelaPermissaoOcorrencias) {
        this.evento.janelaPermissaoOcorrencia = listaJanelaPermissaoOcorrencias;
    }

    // método usado para setar schedule Execucao pelo @output e emit
    aoAdiconarScheduleExecucao(listaScheduleExecucoes) {
        this.evento.scheduleExecucao = listaScheduleExecucoes;
    }

    // método usado para setar Evento Operacao pelo @output e emit
    aoAdiconarEventoOperacao(operacao) {
        operacao.parmOperacao.map((operacaoDados, operacaoKey) => {
            var conteudos = [];
            if (
                operacaoDados.nomeTipoDado != 'bollean' &&
                (operacaoDados.nomeSubtipoDado == 'sel_excl' ||
                    operacaoDados.nomeSubtipoDado == 'sel_mult')
            ) {
                operacaoDados.parmConteudo.map((conteudoDados) => {
                    if (conteudoDados.selecionado == true) {
                        conteudos.push(conteudoDados);
                        operacaoDados.parmConteudo = conteudos;
                    } else {
                        // operacaoDados.parmConteudo = [];
                    }
                });
            }
        });

        // this.operacaos.push(operacao);
        this.evento.detalheEventoOperacao = operacao;
    }

    aoAdiconarEventoProcessamento(eventoProcessamento) {
        this.evento.detalheEventoProcessamento = eventoProcessamento;
    }

    // método usado para setar Evento Transmissao pelo @output e emit
    aoAdicionarTransmissao(eventoTransmissao) {
        this.evento.detalheEventoTransmissao = eventoTransmissao;
        if (Array.isArray(eventoTransmissao.parmTransmissao)) {
            eventoTransmissao.parmTransmissao.map((eventoTransmissaoDados) => {
                var conteudos = [];
                if (
                    eventoTransmissaoDados.nomeTipoDado != 'bollean' &&
                    (eventoTransmissaoDados.nomeSubtipoDado == 'sel_excl' ||
                        eventoTransmissaoDados.nomeSubtipoDado == 'sel_mult')
                ) {
                    eventoTransmissaoDados.parmConteudo.map((conteudoDados) => {
                        if (conteudoDados.selecionado == true) {
                            conteudos.push(conteudoDados);
                            eventoTransmissaoDados.parmConteudo = conteudos;
                        } else if (conteudos.length == 0) {
                            eventoTransmissaoDados.parmConteudo = [];
                        }
                    });
                }
            });
        }

        this.evento.detalheEventoTransmissao = eventoTransmissao;
    }

    // método usado para setar Evento com flag para fechar modal
    aoFinalizarTransmissao(eventoAlterado) {
        this.isEventoSalvar = eventoAlterado;
        this.isNovoEvento = false;
    }

    // método usado para setar Evento Operacao pelo @output e emit
    aoAdicionarOperacao(eventoOperacao) {
        this.evento.detalheEventoOperacao = eventoOperacao;
    }

    // método usado para setar Evento com flag para fechar modal
    aoFinalizarOperacao(eventoAlterado) {
        this.isEventoSalvar = eventoAlterado;
        this.isNovoEvento = false;
    }

    // método usado para setar Evento Permissoes pelo @output e emit
    aoAdicionarPermissoes(eventoPermissoes) {
        this.evento.permissaoUsoEvento = eventoPermissoes.permissaoUsoEvento;
        this.evento.cliente = eventoPermissoes.cliente;
    }

    // método usado para setar Evento Parametros pelo @output e emit
    aoAdicionarParametros(eventoParametros) {
        this.evento.parametrosEntradaEvento = eventoParametros;
    }

    // método usado para setar Evento com flag para fechar modal
    aoFinalizarParametros(eventoAlterado) {
        this.isEventoSalvar = eventoAlterado;
        this.isNovoEvento = false;
    }

    // método usado para setar Evento com flag para fechar modal
    aoFinalizarPermissoes(eventoAlterado) {
        this.isEventoSalvar = eventoAlterado;
        this.isNovoEvento = false;
    }

    aoCancelarEvento(eventoCancelado) {
        // var ftaStorage = localStorage.getItem('fta');
        // this.evento = JSON.parse(ftaStorage);
        // localStorage.removeItem('fta');
        // this.selectedRange = '';
        // this.eventoSelecionado = false;
        // this.eventoCancelado.emit(eventoCancelado.evento);
        // this.isNovoEvento = false;
        //
        // this.selectedRange = '';
        // this.eventoSelecionado = false;
        //this.eventoPrincipal = this.backupEventoPrincipal;
        // this.adicionarFormularioEvento();

        // this.display = false;
        $('#modalEvento').modal('hide');
        // this.isEventoSalvar = false;
        // this.eventoAdicionado.emit(this.evento);
    }

    // método usado para setar Evento com flag para fechar modal
    aoFinalizarProcessamento(eventoAlterado) {
        this.isEventoSalvar = eventoAlterado;
        this.isNovoEvento = false;
    }

    // método usado para finalizar o formulario evento
    finishFunction() {
        if (this.validacaoService.validaEvento(this.evento)) {
            this.adicionarFormularioEvento();
            // this.display = false;
            $('#modalEvento').modal('hide');
            this.isEventoSalvar = false;
        }
    }

    // método usado para excluir o evento selecionado (buton)
    excluirEvento() {
        this.messageService.addSuccessKey(
            'Evento excluído com sucesso.',
            this.chaveComposta
        );

        try {
            this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.splice(
                this.eventoSelecionado,
                1
            );
        } catch (error) {
            console.log(error);
        }
        //this.recalcularEventos();
    }

    msgAjuda(msg) {
        var mensagem;
        switch (msg) {
            case 'Tipo de Evento':
                mensagem = `Selecione o tipo deste evento.`;
                break;
            case 'Descrição':
                mensagem = `Informe uma descrição resumida deste evento..`;
                break;
            case 'Trigger':
                mensagem = `
          Informe qual será o <b>gatilho</b> deste evento.<br><br>
          Observações:<br>
          - Para transmissões de arquivos gerados em servidores de baixa plataforma, iniciadas por um BB SIA Client (que irá acionar o Connect:Direct), selecione o trigger 12;<br>
          - Para transmissões via BB SIA (Web/Client/Rest) com HTTP (sem uso de Connect:Direct), selecione o trigger 2. Este evento irá autorizar o usuário a efetuar o upload;<br>
          - Para transmissões iniciadas via GMTPSEND, selecione entre os triggers 7 a 11 (conforme prioridade informada na chamada do GMTPSEND);<br>
          - Para transmissões iniciadas via IIB (diretamente ou via GMTP0001), selecione o trigger 1;<br>
          - Para evento que só deve ser executado após conclusão de seu(s) evento(s) "dependente(s)", selecione o trigger 4;<br>
          - Para evento que será iniciado automaticamente conforme um determinado cronograma, selecione trigger 5 (será necessário informar schedule, no padrão CRON);<br>
        `;
                break;
            case 'Tipo de periodicidade':
                mensagem = `
        Informe qual a periodicidade prevista para execução deste evento. Atenção: a monitoração de periodicidade ainda não é possível, portanto o registro é, por ora, apenas informativo.
          `;
                break;
            case 'Mensagem Protocolo Sucesso':
                mensagem = `
        Caso o evento termine com RC <= 4, será registrada esta mensagem no protocolo do usuário. O usuário (mesmo externo) será capaz de visualizar a mensagem.<br>
        É possível a utilização de variáveis do BB SIA.
          `;
                break;
            case 'Mensagem Protocolo Erro':
                mensagem = `
        Caso o evento termine com RC > 4, será registrada esta mensagem no protocolo do usuário. O usuário (mesmo externo) será capaz de visualizar a mensagem.<br><br>
        É possível a utilização de variáveis do BB SIA.
            `;
                break;
            case 'Formato Chave':
                mensagem = `
          Indica a forma que será construída a <b>chave</b> de correlação deste protocolo.<br>
          Este campo permite a utilização de variáveis do BB SIA.<br>
          Uma chave de correlação permite que eventos totalmente assíncronos sejam relacionados em um mesmo protocolo. Por exemplo: <br>
          1º evento -> transmissão do arquivo BB.EX001.D101010.R001.txt de um servidor para o Mainframe<br>
          2º evento -> transmissão do arquivo BRP.EX001.D101010.R001.SS000101 do Mainframe para um servidor<br><br>
          Os eventos tem a configuração da seguinte forma:<br>
          1º evento constroi a chave como: posições 4 até 21 do nome do arquivo de origem (EX001.D101010.R001)<br>
          2º evento constroi a chave como: posições 5 até 22 do nome do arquivo de origem (EX001.D101010.R001)<br>
          Ou seja, ambos eventos montaram exatamente a mesma chave, e serão agrupados no mesmo protocolo, fazendo o protocolo encerrar com sucesso.<br>
          Atenção: quando é utilizado CHAVE em qualquer evento, TODOS os demais eventos do protocolo devem compartilhar da mesma chave, ou então teremos protocolos "em andamento" indefinidamente.<br>
              `;
                break;
            case 'Subfluxo vinculado':
                mensagem = `
          Subfluxos são utilizados para viabilizar <b>caminhos de contingência</b> manuais. Por exemplo:<br>
          Subfluxo 1 -> Transmite o arquivo do cliente para um servidor, para processamento por uma aplicação de baixa plataforma.<br><br>
          Subfluxo 2 -> Transmite o arquivo do cliente para o Mainframe, para processamento pelo sistema legado.<br><br>
          Em caso de indisponibilidade do servidor de baixa plataforma, o operador pode, emergencialmente, alterar o subfluxo vigente para '2', de forma a não parar o atendimento ao cliente.<br><br>
          A solução BB SIA, durante seu funcionamento, somente enxerga os eventos que estejam vinculados ao subfluxo atualmente vigente. `;
                break;
            case 'Grupos':
                mensagem = `
          Grupos:
          Permite que diferentes "caminhos" sejam possíveis para um fluxo (deste que previstos), possibilitando que cada "caminho" possível encerre um protocolo com sucesso.<br><br>

          Para que um protocolo encerre com sucesso, é necessário que todos os eventos de um grupo (seja ele qual for) sejam concluídos com sucesso.<br><br>

          Por exemplo: Um FTA possui 1 remessa do cliente para o Mainframe. O mainframe pode seguir 2 caminhos:<br><br>
          A) Gerar 1 arquivo retorno de sucesso; ou
          B) Gerar 2 arquivos retorno, 1 contendo uma mensagem personalizada de recusa e 1 contendo um dump da aplicação.<br><br>

          Em nosso FTA, teríamos os seguintes eventos/grupos:<br>
          - Evento 1 (remessa do cliente) -> Grupos 1 e 2<br>
          - Evento 2 (cenário A do exemplo, retorno sucesso) -> Grupo 1<br>
          - Evento 3 (cenário B do exemplo, retorno recusa) -> Grupo 2<br>
          - Evento 4 (cenário B do exemplo, retorno dump) -> Grupo 2<br><br>


          Ao final, independentemente do resultado, ou o grupo 1 ou o grupo 2 seriam concluidos inteiramente, encerrando o protocolo com sucesso.<br>
          `;
                break;
            default:
                break;
        }

        // this.clearMsgAjuda();

        this.modalService.exibirMensagem(`${msg}.\n`, `${mensagem}`, 'Fechar');
    }

    ajudaVariaveis() {
        this.modalService
            .abrirPaginaModal(
                'ajuda-variaveis-modal',
                {},
                {pesquisar: false},
                'Ajuda Variáveis',
                'Fechar'
            )
            .subscribe((ajuda) => {
            });
    }

    async moveEvento(
        nuEtapa,
        nuEvento,
        totalEtapaSelecionada,
        eventoIndex,
        move
    ) {
        this.evento.evento = nuEvento;
        this.evento.etapa = nuEtapa;

        await this.carregaEvento();

        var eventoSelecionado = this.evento;

        var etapaEvento = totalEtapaSelecionada;
        if (move == '+') {
            this.evento.etapa = nuEtapa + 1;
            totalEtapaSelecionada++;
        } else {
            this.evento.etapa = nuEtapa - 1;
            totalEtapaSelecionada--;
        }

        this.arrayEvento = [];

        this.eventoPrincipal.etapas.map((etapaValue, etapaIndex) => {
            etapaValue.eventos.map((eventoValue, EventoIndex: any) => {
                if (eventoValue.etapa == nuEtapa && eventoValue.evento == nuEvento) {
                    etapaValue.eventos.splice(EventoIndex, 1);
                    this.eventoPrincipal.etapas[totalEtapaSelecionada].eventos.push(
                        this.evento
                    );
                }
            });
        });

        this.eventoPrincipal.etapas.map((etapaValue, etapaIndex) => {
            etapaValue.eventos.map((eventoValue, EventoIndex: any) => {
                this.arrayEvento.push(eventoValue);
            });
        });

        this.eventoPrincipal.etapas[totalEtapaSelecionada].eventos.sort(
            (a: any, b: any) => parseFloat(a.evento) - parseFloat(b.evento)
        );
        this.arrayEvento.sort(
            (a: any, b: any) => parseFloat(a.evento) - parseFloat(b.evento)
        );

        await this.carregaEvento();

        this.adicionarFormularioEvento();
    }

    duplicarEvento(nuEtapa, nuEvento, totalEtapaSelecionada) {
        if (this.evento === null) {
            this.evento = new Evento();
        }
        // Carrega o evento
        this.evento.evento = nuEvento;
        this.evento.etapa = nuEtapa;
        this.carregaEvento();

        // Clona todo o evento para eventoDuplicado para manter o evento no qual sera duplicado.
        var eventoDuplicado = this.evento;

        eventoDuplicado.parametrosSelecionados = [];
        eventoDuplicado.parametrosSelecionadosOperacao = [];

        this.etapaSelecionado = totalEtapaSelecionada;
        let btn: BntProps = new BntProps();
        var totalBtns = 0;
        let eventoAux = new Evento();

        if (totalEtapaSelecionada < 1) {
            btn.label = 'Evento ';
            btn.index =
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.length +
                1;
            this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
            //this.eventoPrincipal.etapas[this.etapaSelecionado].indexEvento = this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.length;
        } else {
            totalBtns = this.totalDeBtnsEmTela(
                this.eventoPrincipal.etapas,
                this.etapaSelecionado
            );
            let proximoIndexBtn = totalBtns + 1;

            if (
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.length < 1
            ) {
                btn.label = 'Evento';
                // btn.index = proximoIndexBtn;
                btn.index = this.recuperaUltimoEvento();
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
            } else {
                btn.label = 'Evento';
                // btn.index = totalBtns + 1;
                btn.index = this.recuperaUltimoEvento();
                this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
            }
            //this.recalcularEventos();
        }

        eventoAux.etapa = nuEtapa;
        eventoAux.evento = this.recuperaUltimoEvento();
        eventoAux.descricao = '????';
        //index evento etapa
        let indiceEventoEtapa =
            this.eventoPrincipal.etapas[this.etapaSelecionado].eventos.length;
        if (indiceEventoEtapa == 0) {
            this.eventoPrincipal.etapas[this.etapaSelecionado].indexEvento =
                indiceEventoEtapa;
        } else {
            this.eventoPrincipal.etapas[this.etapaSelecionado].indexEvento =
                indiceEventoEtapa + 1;
        }

        //this.eventoPrincipal.etapas[this.etapaSelecionado].botoesList.push(btn);
        this.eventoPrincipal.etapas[this.etapaSelecionado].eventos.push(eventoAux);

        this.eventoSelecionado = btn.index;
        this.etapaSelecionado = totalEtapaSelecionada;
        this.evento = eventoDuplicado;
        this.evento.etapa = nuEtapa;
        this.evento.evento = this.recuperaUltimoEvento();

        //this.carregaEvento();

        this.abrirModal();
        this.indexEtapa = totalEtapaSelecionada;
        this.indexEvento =
            this.eventoPrincipal.etapas[this.etapaSelecionado].eventos.length - 1;
        this.isNovoEvento = true;
    }

    //remove evento pelo botao lixeira
    removerEvento(
        indexEtapa: number,
        indexEvento: number,
        numeroEvento: number,
        numeroEtapa: number
    ): void {

        console.log(indexEtapa, indexEvento, numeroEtapa, numeroEvento);

        //remove evento da lista de etapas
        this.eventoPrincipal.etapas[indexEtapa].eventos.splice(indexEvento, 1);

        //remove evento da lista de botoes e arrayEvento
        for (let i in this.arrayEvento) {
            if (
                this.arrayEvento[i].etapa == numeroEtapa &&
                this.arrayEvento[i].evento == numeroEvento
            ) {
                this.arrayEvento.splice(parseInt(i), 1);
                this.eventoPrincipal.etapas[indexEtapa].botoesList.splice(
                    parseInt(i),
                    1
                );
            }
        }

        //this.recalcularEventos();
        this.excluirEvento();
    }

    definirTipoEvento(tipo) {
        this.tipoEvento.codigo = tipo;
        this.habilitaTipoEvento();
    }

    // método usado para recalcular os eventos a partir de sua exclusão.
    recalcularEventos() {
        let btn: BntProps = new BntProps();
        let posicaoBtn = 0;
        let numeroEvento = 1;
        let posicaoEtapa = 0;

        let evt: EventoPrincipal = new EventoPrincipal();

        for (let et of this.eventoPrincipal.etapas) {
            let etapa = new Etapa();

            posicaoEtapa++;

            et.botoesList.forEach((elementBtn) => {
                posicaoBtn++;
                elementBtn.index = posicaoBtn;
                etapa.botoesList.push(elementBtn);
            });

            //ajusta os numeros de eventos dentro de cada etapa
            if (et.eventos.length > 0) {
                for (let i in et.eventos) {
                    et.eventos[i].evento = numeroEvento;
                    numeroEvento++;
                }
            }

            //atualiza evento etapa
            etapa.eventos = et.eventos;

            evt.etapas.push(etapa);
        }
        this.eventoPrincipal = evt;
    }

    onSubmitSelected(f: NgForm) {
        f.reset();
    }

    // método usado para adicionar no grupo
    aoAdiconarGrupo() {
        for (var posicao = 0; posicao < this.evento.grupo.length; posicao++) {
            if (this.evento.grupo[posicao] == this.novoGrupo) {
                //  existe = true;
                this.messageService.addErrorKey(
                    'Grupo já está adicionado ao evento.',
                    this.chaveComposta
                );
                return;
            }
        }

        this.evento.grupo.push(Number(this.novoGrupo));

        this.loadingGrupo = true;

        this.novoGrupo = null;
    }

    // método usado para remover do grupo
    removerGrupo(indice: any) {
        const index = this.evento.grupo.indexOf(indice);

        this.evento.grupo.splice(index, 1);

        if (this.evento.grupo.length === 0) {
            this.loadingGrupo = false;
        }
    }

    adicionarGrupo(grupo) {
        if (this.checkedGrupo[grupo.value] == true) {
            this.evento.grupo.push(grupo.value);
        } else {
            const index = this.evento.grupo.indexOf(grupo.value);

            this.evento.grupo.splice(index, 1);

            if (this.evento.grupo.length === 0) {
                this.loadingGrupo = false;
            }
        }

        let removeGruposDuplicados = this.evento.grupo.filter(
            (value, index) => this.evento.grupo.indexOf(value) == index
        );

        this.evento.grupo = removeGruposDuplicados;
    }

    valida() {
        this.botaoFinalizar = true;
    }

    //metodo que trata o tipo evento anterior
    tratarDependencia(valor): void {
        if (valor != '4') {
            this.evento.dependencia = [];
        }
    }

    trataDependenciaEvento(valor) {
        let remover: boolean = false;
        let exibirMsgEtapa = true;
        let eventosEtapaAnterior;

        if (this.evento.etapa > 1) {
            eventosEtapaAnterior =
                this.eventoPrincipal.etapas[this.evento.etapa - 2].eventos;
            if (eventosEtapaAnterior.length == 0 && valor == '4') {
                this.exibirMsgEtapaEvento();
            }
        } else if (this.evento.etapa == 1 && valor == '4') {
            this.exibirMsgEtapaEvento();
        }

        if (this.evento.dependencia.length > 0 && valor != '4') {
            $.confirm({
                title: 'Atenção!',
                content:
                    'Existe(m) evento(s) anteriores cadastrado(s). Deseja removê-lo(s)?',
                buttons: {
                    Ok: function () {
                        remover = true;
                    },
                    Cancelar: function () {
                    },
                },
                onClose: () => {
                    if (remover) {
                        this.evento.dependencia = [];
                        this.evento.qtdSegundosMaxEntreEventos = null;
                    }
                },
            });

            if (remover) {
                this.evento.dependencia = [];
            }
        }
    }

    exibirMsgEtapaEvento() {
        let limparTrigguer = false;
        $.confirm({
            title: 'Atenção!',
            content:
                'Não existe nenhum evento cadastrado em uma etapa anterior. Favor selecione outra opção.',
            buttons: {
                Ok: function () {
                    limparTrigguer = true;
                },
                Cancelar: function () {
                },
            },
            onClose: () => {
                if (limparTrigguer) {
                    this.evento.codTipoTrigger = null;
                    this.tipoTrigger.codigo = null;
                    this.tipoTrigger.nome = null;
                    this.tipoTrigger.descricao = null;
                }
            },
        });
    }

    salvar() {
        $('#btnSalvarTransmissao').click();
    }
}



// WEBPACK FOOTER //
// ./src/app/cadastro-evento/cadastro-evento.component.ts